module.exports = __webpack_public_path__ + "assets/img/pro-price-logo.7de113d0.svg";